import { useState } from 'react'

const useModal = () => {
  const [isOpen, setIsOpen] = useState<boolean>(false)

  // Open the modal
  const openModal = () => {
    setIsOpen(true)
  }

  // Close the modal
  const closeModal = () => {
    setIsOpen(false)
  }

  return { isOpen, closeModal, openModal }
}

export default useModal
